<template>
    <div class="home">
        <b-container>
            <b-row class="mt-5">
                <b-col lg="4" class="pt-3">
                    <img class="logo" src="@/assets/thepaymentoption-logo-white.svg"/>
                    <copyright class="dark mt-5 d-none d-lg-block"/>
                    <div class="mt-5 d-block d-lg-none"></div>
                </b-col>
                <b-col>
                    <div class="box mt-0 mb-5">
                        <div v-if="!instructions && !notFound && !error">
                            <h3><i class="far fa-lock-alt mr-3"></i>Access Your Accounts</h3>

                            <p class="d-none d-md-block">What is your <strong>E-Mail Address</strong> or <strong>Phone Number</strong>?</p>
                            <p class="d-xs-block d-md-none"><strong>E-Mail Address</strong> or <strong>Phone Number</strong></p>
                            <b-input class="request" autocomplete="false" v-model="login" v-mask="mask"></b-input>
                            <b-button variant="primary" size="lg" block :disabled="invalid || processing" class="mb-3" @click="requestLogin"><span v-if="!processing">Submit <i class="far fa-long-arrow-right ml-2"></i></span><span v-else><i class="far fa-sync fa-spin mr-3"></i>Please wait...</span></b-button>
                        </div>
                        <div v-if="instructions">
                            <h3><i class="far fa-lock-alt mr-3"></i>Access Your Accounts</h3>

                            <div v-if="method==='email'" class="ml-2">
                                <p><i class="far fa-fw fa-thumbs-up mr-2"></i><strong>Check your e-mail</strong> for a login link to access your accounts.</p>
                                <div style="margin-left: 30px;">
                                    <p>If you don't see an e-mail please check your spam folders and filters.  This request will expire in 10 minutes.  If you need assistance please <a href="mailto:help@thepaymentoption.com">contact us</a>.</p>
                                    <p class="mt-2">You may close this window or tab or <a href @click="instructions=false" class="font-weight-bold">try again</a>.</p>
                                </div>
                                <p class="mt-3">
                                    <!--                        <b-button variant="outline" @click="help=true">I need more help...</b-button>-->
                                </p>
                            </div>
                            <div v-else-if="method==='sms'">
                                <p><i class="far fa-fw fa-thumbs-up mr-2"></i><strong>Check your phone</strong> for your one time use access code.</p>

                                <div class='access-code'>
                                    <b-form-group label="Access Code">
                                        <div class='code-container'>
                                            <v-otp-input
                                                ref="otpInput"
                                                input-classes="otp-input"
                                                separator="-"
                                                :num-inputs="5"
                                                :should-auto-focus="true"
                                                :is-input-num="true"
                                                @on-change="handleOnChange"
                                                @on-complete="handleOnComplete"
                                            />
                                        </div>
                                    </b-form-group>
                                    <b-alert class="mt-2" v-if="smsError" show variant="danger">The access code you entered is not valid.  If it's been more than five (5) minutes since your request then it has expired.  Please check it or <a class="try-again" @click="instructions=false; code=null;">start over</a>.</b-alert>

                                    <b-button variant="primary" :disabled="!code || code.length < 5" @click="verifySms" class="mt-4"><span v-if="!processing">Submit <i class="far fa-long-arrow-right ml-2"></i></span><span v-else><i class="far fa-sync fa-spin mr-2"></i>Please wait...</span></b-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="notFound">
                            <h3><i class="far fa-lock-alt mr-3"></i>Access Your Accounts</h3>
                            <p><i class="far fa-ban mr-2 text-danger"></i>We don't see any accounts for that e-mail address or phone number. Please use the same address on file with your merchant and verify that your account has been set up and activated. If you need assistance please <a href="mailto:help@thepaymentoption.com">contact us</a>.</p>
                            <p class="mt-4">
                                <b-button variant="primary" @click="notFound=false; error=false"><i class="far fa-arrow-left mr-2"></i>Try Again</b-button>
                            </p>
                        </div>
                        <div v-if="error">
                            <h3><i class="far fa-lock-alt mr-3"></i>Access Your Accounts</h3>
                            <p><i class="far fa-ban mr-2 text-danger"></i>Oh no! An error occurred. Please try again or contact your merchant for help.</p>
                            <p class="mt-4">
                                <b-button variant="primary" @click="notFound=false; error=false"><i class="far fa-arrow-left mr-2"></i>Try Again</b-button>
                            </p>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <copyright class="dark mt-5 d-block d-lg-none text-center"/>

        </b-container>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from 'vuex';
    import axios from "axios";
    import {apiUrl} from "@/constants/config";

    export default {
        name: 'Home',
        components: {Copyright},
        data: function() {
            return {
                code: null,
                notFound: null,
                error: null,
                smsError: null,
                instructions: false,
                login: '',
                processing: false,
                method: null
            };
        },
        computed: {
            mask: function() {
                if (this.login && this.login.match(/[a-zA-Z@\.]+/)) {
                    return 'ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ';
                } else {
                    return '(ZZZ) ZZZ-ZZZZZZZZZZZZ';
                }

            },
            invalid: function() {
                return !((!this.login.match(/[a-zA-Z@\.]+/) && this.login.replace(/\D/g, '').length === 10) || this.login.match(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/));
            }
        },
        methods: {
            ...mapActions(['makeLoginRequest']),
            requestLogin() {
                if (!this.processing) {
                    this.processing = true;
                    this.smsError = false;
                    this.login = this.login.trim();

                    this.method = (this.login.match(/@/)) ? 'email' : 'sms';
                    this.makeLoginRequest({request: this.login, method: this.method}).then(() => {
                        this.processing = false;
                        this.instructions = true;
                    }).catch(err => {
                        if (err.status === 404) {
                            this.notFound = true;
                        } else {
                            this.error = true;
                        }
                        this.processing = false;
                    });
                }
            },
            verifySms() {
                if (!this.processing) {
                    this.smsError = false;
                    this.processing = true;

                    axios.post(apiUrl + 'api/user/sms_login/', {number: this.login.replace(/\D/g, ''), code: this.code}).then(response => {
                        this.$router.push({name: 'accounts', params: {code: response.data.session}})
                    }, err => {
                        this.$refs.otpInput.clearInput();
                        this.code = null;
                        this.smsError = true;
                        this.processing = false;
                    });
                }
            },
            handleOnComplete(value) {
                this.code = value;
                if (this.code.length === 5) {
                    this.verifySms()
                }
            },
            handleOnChange(value) {
                this.code = value;
            }
        }
    };
</script>

<style lang="scss">

    @import '~@/assets/scss/_variables.scss';

    .home {
        display: flex;
        min-height: 100vh;

        background-color: #3c3c5f;
        padding: 1rem;
        color: #5c5c5c;

        .logo {
            width: 90%;
            max-width: 250px;
        }

        .box {
            padding: 2rem 3rem;
            background: white;
            /*margin: 5rem;*/
            border-radius: 0.5rem;
            box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);

            h1, h3 {
                color: $primary;
                letter-spacing: -0.08rem;
                margin-bottom: 2rem;

                @media only screen and (max-width: 600px) {
                    font-size: 1.5rem;
                }
            }

            input.request {
                &.large {
                    font-weight: bold;
                    padding: 2.5rem;
                    letter-spacing: 0.3rem;
                    font-size: 2.5rem;
                }

                margin-bottom: 2rem;

                color: $primary;
            }

            .btn {
                i {
                    //margin-left: 0.7em;
                }
            }

            .access-code {
                margin-left: 1.9rem;

                .code-container {
                    margin-left: -0.7rem
                }

                @media only screen and (max-width: 600px) {
                    margin-left: 0;
                }
            ;

            }

            @media only screen and (max-width: 600px) {
                padding: 1.5rem 0.9rem;
            }

        }
    }

    .try-again {
        text-decoration: underline !important;
        cursor: pointer;
    }

    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        text-align: center;

        &.error {
            border: 1px solid red !important;
        }
    }

    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
